// Build the `errors` payload for a vocabulary fill-in attempt.
//
// `userResponses` is keyed by the exercise's ARRAY INDEX (currentExerciseIndex),
// NOT by Vocabulary.id. We must map each index back to its row so that:
//   - exercise_id is the real Vocabulary primary key (Vocabulary IDs are large DB
//     PKs, never 0..N-1, so the old `exercises.find(ex => ex.id == index)` always
//     missed → undefined correct_answer and an index masquerading as a PK), and
//   - correct_answer is populated.
// This payload is persisted on the attempt and fed verbatim into the AI
// motivational-feedback prompt, so wrong references degrade that feedback.
export function buildVocabularyFillinErrors(userResponses, exercises) {
  const errors = [];
  Object.entries(userResponses).forEach(([index, response]) => {
    if (!response.correct && !response.seen) {
      const exercise = exercises[Number(index)];
      errors.push({
        exercise_id: exercise?.id,
        user_answer: response.answer,
        correct_answer: exercise?.correct_answer,
      });
    }
  });
  return errors;
}
